import { api } from "../../plugins/api"
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    transmissionOrdre: {
      id: "",
      demandeAdmission: "",
      pp: "",
      nePasDivulguerMesCoordonnees: false,
      raison: null,
      precision: "",
      active: true,
      contribution: [],
    },
  }
}

const state = getDefaultState()

const getters = {
  GET_TRANSMISSIONORDRE: (state) => {
    return state.transmissionOrdre
  },
}

const mutations = {
  SET_ID(state, id) {
    state.transmissionOrdre.id = id
  },
  SET_CONTACTID(state, id) {
    state.transmissionOrdre.pp = id
  },
  SET_DEMANDEADMISSIONID(state, id) {
    state.transmissionOrdre.demandeAdmission = id
  },
  SET_TRANSMISSIONORDRE(state, dto) {
    state.transmissionOrdre = { ...dto }
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async getTransmissionOrdreByContactId({ commit }, contactId) {
    const response = await api.get(`transmissionsordres/contacts/` + contactId)
    commit("SET_TRANSMISSIONORDRE", response.data)
  },
  async getTransmissionOrdreByDemandeAdmissionId({ commit }, demandeAdmissionId) {
    const response = await api.get(`transmissionsordres/demandesadmissions/` + demandeAdmissionId)
    commit("SET_TRANSMISSIONORDRE", response.data && response.data[0] ? response.data[0] : getDefaultState().transmissionOrdre)
  },
  async getTransmissionOrdreByDemandeInscriptionId({ commit }, demandeInscriptionId) {
    const response = await api.get(`transmissionsordres/demandesinscriptions/` + demandeInscriptionId)
    commit("SET_TRANSMISSIONORDRE", response.data && response.data[0] ? response.data[0] : getDefaultState().transmissionOrdre)
  },
  async createTransmissionOrdre({ commit }, pSASAdmissionsDTO) {
    const response = await api.post(`transmissionsordres`, pSASAdmissionsDTO)
    commit("SET_ID", response.data)
  },
  async getLinkedContactEncryptedId({ commit }, encryptedId) {
    const response = await api.get(`transmissionsordres/${encryptedId}/contact`)
    commit("SET_CONTACTID", response.data ? response.data : null)
  },
  async updateTransmissionOrdre({ commit }, pSASAdmissionsDTO) {
    const response = api.put(`transmissionsordres`, pSASAdmissionsDTO)
    commit("SET_TRANSMISSIONORDRE", response.data ? response.data : null)
  },
  getTransmissionOrdre({ state }, encryptedId) {
    return api.get(`transmissionsordres/` + encryptedId)
  },
  resetModuleState({ commit }) {
    commit("resetState")
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
}